import React, {useState, useCallback, useEffect} from 'react'
import {GoogleMap, useJsApiLoader} from '@react-google-maps/api'
import {MINZOOM} from 'helpers/locations'
import {formatDateTime, formatTimestamp} from 'helpers/dates'

const mapContainerStyle = {
  width: '100%',
  height: '100%'
}

const PathMap = ({locations = [], minZoom = MINZOOM.TENANTS}) => {
  const [map, setMap] = useState(null)

  const {isLoaded} = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  })

  const onLoad = useCallback(mapInstance => {
    setMap(mapInstance)
  }, [])

  useEffect(() => {
    if (!map || !locations.length) return

    const bounds = new window.google.maps.LatLngBounds()

    const maxSize = 10
    const minSize = 3

    const markers = locations.map((location, index) => {
      const lat = parseFloat(location.latitude)
      const lng = parseFloat(location.longitude)
      const position = {lat, lng}

      bounds.extend(position)

      // Calculate marker size and color gradient
      const t = index / (locations.length - 1 || 1)
      const size = minSize + (maxSize - minSize) * t
      const redValue = Math.round(255)
      const greenBlue = Math.round(255 - t * 200)
      const fillColor = `rgb(${redValue}, ${greenBlue}, ${greenBlue})`

      const info = location.info || {}
      const tooltip = [
        `${formatTimestamp(location.timestamp)}`,
        `${parseFloat(location.latitude).toFixed(6)}, ${parseFloat(location.longitude).toFixed(6)}`,
        ...Object.entries(info).map(([key, value]) => `${key}: ${value}`)
      ].join('\n')

      return new window.google.maps.Marker({
        position,
        title: tooltip,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          fillColor,
          fillOpacity: 1,
          strokeWeight: 0,
          scale: size
        },
        map
      })
    })

    map.fitBounds(bounds)

    setTimeout(() => {
      const currentZoom = map.getZoom()
      if (currentZoom > minZoom) {
        map.setZoom(minZoom)
      }
    }, 100)

    return () => {
      markers.forEach(marker => marker.setMap(null))
    }
  }, [map, locations, minZoom])

  if (!isLoaded) return <div>Loading map...</div>

  return (
    <GoogleMap
      id="path-map"
      mapContainerStyle={mapContainerStyle}
      onLoad={onLoad}
      options={{
        mapTypeId: 'hybrid',
        controlSize: 18,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true
      }}
    />
  )
}

export default PathMap
